import React from "react";

type ReadMoreProps = {
  children: string; // HTML string
  characters?: number;
  className?: string;
};

const ReadMore: React.FC<ReadMoreProps> = ({
  children,
  characters = 300,
  className = "",
}) => {
  if (!children) return null;
  const isTruncated = children.length > characters;
  const truncatedText = isTruncated
    ? children.slice(0, characters) + "..."
    : children;

  return (
    <div className={className}>
      <div
        className="relative overflow-hidden leading-5"
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
        }}
        dangerouslySetInnerHTML={{
          __html: isTruncated
            ? `${truncatedText} <span class="text-gray-600 font-semibold">Read more</span>`
            : children,
        }}
      />
    </div>
  );
};

export default ReadMore;
